import Property from './Property';
import Upgrade from './Upgrade';
import Guest from './Guest';

export default {
    Property,
    Upgrade,
    Guest
}